'use client';
import React from 'react';
import { Box } from '@skin-seoul/design-system';

import { CampaignSectionTitle, CampaignSectionSubTitle } from '../components/CampaignSectionHeader';
import AmazonProductList from './AmazonProductList';
import SectionContainer from '../components/SectionContainer';
import SectionHeader from '../components/SectionHeader';
import { ProductGrid, ProductGridSkeleton } from '../components/ProductGrid';
import ViewAllButton from '../components/ViewAllButton';
import QueryBoundary from '../../utils/react/QueryBoundary';

export const AmazonSection = () => {
  const handleViewAll = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/campaign/ggu-lowest-price/';
    }
  };
  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'black',
        alignItems: 'center',
        gap: '48px',
      }}
    >
      <Box
        width="100%"
        flexDirection="column"
        alignItems="flex-start"
        margin={0}
        justifyContent="flex-start"
        gap="12px"
        display={{ base: 'none', desktop: 'flex' }}
      >
        <CampaignSectionTitle theme="dark">Lowest Prices In The World</CampaignSectionTitle>
        <CampaignSectionSubTitle theme="dark">Better than the other mega sale</CampaignSectionSubTitle>
      </Box>
      <SectionHeader
        theme="dark"
        title="Lowest Prices In The World"
        subtitle="Better than the other mega sale"
        display={{ base: 'flex', desktop: 'none' }}
        href="/campaign/ggu-lowest-price/"
      />
      <QueryBoundary clientOnly loadingFallback={<ProductGridSkeleton length={5} />}>
        <ProductGrid>
          <AmazonProductList />
        </ProductGrid>
      </QueryBoundary>
      <ViewAllButton onClick={handleViewAll} theme="dark" />
    </SectionContainer>
  );
};
